import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
  Tooltip,
} from "@mui/material";
import { getMenuItems } from "./menuConf";
import { Link, useLocation } from "react-router";
import {
  listItemButtonStyles,
  listItemIconStyles,
} from "../../styles/commonStyles";
import { useSelector } from "react-redux";

const MenuSide = ({ isDrawerOpen, desktopWidth }) => {
  const theme = useTheme();
  const location = useLocation();

  const userType = useSelector((state) => state.me?.data?.data?.type);
  const menuItems = getMenuItems(userType);

  return (
    <List sx={{ height: "100%", paddingX: 2 }}>
      {menuItems.map((item, index) => {
        const isSelected = location.pathname.startsWith(item.route);
        const listItem = (
          <ListItemButton
            key={index}
            component={Link}
            to={item.route}
            selected={isSelected}
            sx={listItemButtonStyles(theme, desktopWidth)}
          >
            <ListItemIcon sx={listItemIconStyles(theme)}>
              {item.icon}
            </ListItemIcon>
            {isDrawerOpen && (
              <ListItemText
                primary={item.text}
                sx={{
                  ml: 1,
                  "& .MuiListItemText-primary": {
                    fontWeight: 500,
                    fontSize: "12px",
                    lineHeight: "100%",
                    letterSpacing: "0%",
                  },
                }}
              />
            )}
          </ListItemButton>
        );

        return isDrawerOpen ? (
          listItem
        ) : (
          <Tooltip key={index} title={item.text} placement="right">
            {listItem}
          </Tooltip>
        );
      })}
    </List>
  );
};

export default MenuSide;
